import { updatePageLinks } from 'core/router';
import { extractInfoFromXhr } from 'navigation/page-manager/CustomPageManager';
import InternalPage from 'navigation/pages/InternalPage';
import browser from 'helpers/browser';
import store from 'store';
import ProductCard from 'sections/product/partials/ProductCard';
import CatalogPush from 'components/catalog-push/CatalogPush';
import { bindEmitterMethod } from 'helpers/bind';
import { forceArray } from 'navigation/component/Component';
import Pagination from 'components/pagination/Pagination';
import RevealList from 'components/reveal-list/RevealList';
import scroll from 'core/scroll';
const MAX_LAST_STATES = 10;
export const findMostPopularNumber = (arr) => {
    // Initialize an object to hold counts of each number
    const counts = {};
    // Iterate over the array to count occurrences of each number
    arr.forEach(num => {
        if (counts[num])
            counts[num]++;
        else
            counts[num] = 1;
    });
    // Find the number(s) with the highest occurrence
    const maxCount = Math.max(...Object.values(counts));
    const mostPopularNumbers = Object.keys(counts).filter(key => counts[key] === maxCount);
    // Return the most popular number or numbers if there's a tie
    return parseInt(mostPopularNumbers[0]);
};
class CategoryProducts extends InternalPage {
    endpoint;
    loading = false;
    preloadingPages;
    io;
    cullingIo;
    visibleProducts = [];
    idx;
    currentPage = window.location.search.includes('page=') ? parseInt(window.location.search.split('page=')[1]) : 1;
    minPageLoaded = this.currentPage;
    hidden = false;
    previousPage = null;
    bindModules() {
        super.bindModules();
    }
    pageName() {
        return 'CategoryProducts';
    }
    initialized() {
        super.initialized();
        this.idx = window.history.state?.idx;
        if (this.refs.categoryList)
            this.endpoint = this.refs.categoryList.getAttribute('data-src');
        this.io = new IntersectionObserver(this.watchPageScrollChange.bind(this), { threshold: [1] });
        this.cullingIo = new IntersectionObserver(this.cullingCallback.bind(this), {
            rootMargin: '0px 0px 100px 0px'
        });
        if (this.refs.products) {
            for (let i = 0; i < this.refs.products.length; i++) {
                this.io.observe(this.refs.products[i]);
                this.cullingIo.observe(this.refs.products[i]);
            }
        }
    }
    restore = () => {
        const lastCategories = store.lastCategories.get();
        const filters = this.el.dataset.filters;
        const backup = lastCategories.find((s) => { return s.id === this.el.dataset.id && s.filters === filters && s.minPageLoaded <= this.currentPage; });
        if (backup?.items?.length) {
            console.log(`BACKUP FOUND ${backup?.items?.length}`);
            this.refs.categoryList.innerHTML = '';
            backup.items?.forEach(el => {
                this.refs.categoryList.append(el);
            });
            const pagination = forceArray(this.modules.pagination);
            const prevPagination = pagination.find(p => p?.el.classList.contains('previous'));
            const nextPagination = pagination.find(p => p?.el.classList.contains('next'));
            if (backup.minPageLoaded === 1)
                prevPagination?.el.remove();
            console.log(`BACKUP INJECTED ${this.refs.categoryList.children.length}`);
            nextPagination?.setSeen(backup.seen);
            this.minPageLoaded = backup.minPageLoaded;
            this.modules.revealList.reset();
        }
        else {
            console.log('BACKUP NOT FOUND');
        }
        return Promise.resolve();
    };
    resetScroll = () => {
        console.log('reset scroll');
        scroll.unlock();
        const lastCategories = store.lastCategories.get();
        const backup = lastCategories.find((s) => { return s.id === this.el.dataset.id && s.stateIdx === this.idx; });
        if (backup)
            document.scrollingElement.scrollTop = backup.top;
        else
            scroll.resetScroll();
        return Promise.resolve();
    };
    getModulesMap() {
        return {
            productCard: ['.search-results__product .product-card, .category__product:not(carousel-hidden) .product-card', ProductCard],
            catalogPush: ['.catalog-push__links, .catalog-push__edito', CatalogPush],
            revealList: ['.category__list', RevealList],
            pagination: ['.pagination', Pagination]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            pages: this.refs.categoryList?.getAttribute('data-nb-pages'),
            current: this.refs.categoryList?.getAttribute('data-page'),
            seen: Array.from(this.refs.categoryList?.querySelectorAll('.category__product, .search-results__product') || []).length
        };
    }
    cullingCallback(entries) {
        for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting)
                entries[i].target.classList.remove('carousel-hidden');
            else
                entries[i].target.classList.add('carousel-hidden');
        }
        this.refresh();
    }
    watchPageScrollChange(entries) {
        for (let i = 0; i < entries.length; i++) {
            const video = entries[i].target.querySelector('video');
            if (entries[i].isIntersecting) {
                this.visibleProducts.push(entries[i].target);
            }
            else {
                const index = this.visibleProducts.indexOf(entries[i].target);
                if (index > -1)
                    this.visibleProducts.splice(index, 1);
            }
        }
        // determine the current page by getting the most popular page in data-page on visible products
        const pages = this.visibleProducts.map(p => p.getAttribute('data-page'));
        // in the pages array, determine which values is the most present and output it
        if (pages.length) {
            const current = findMostPopularNumber(pages);
            if (current !== this.currentPage) {
                this.currentPage = current;
                if (this.currentPage > 1)
                    window.history.replaceState({ idx: this.idx }, '', this.endpoint + (~this.endpoint.indexOf('?') ? '&' : '?') + 'page=' + this.currentPage);
                else if (!this.hidden)
                    window.history.replaceState({ idx: this.idx }, '', this.endpoint);
            }
        }
    }
    bindEvents(add = true) {
        const emitterMethod = bindEmitterMethod(add);
        forceArray(this.modules.productCard || []).forEach(p => {
            p[emitterMethod]('click', this.onItemClick);
        });
        forceArray(this.modules.catalogPush || []).forEach(p => {
            p[emitterMethod]('click', this.onItemClick);
        });
        forceArray(this.modules.pagination || []).forEach(p => {
            p[emitterMethod]('load', (page, direction) => this.loadNewPage(page, direction));
        });
    }
    onItemClick = (e) => {
        store.lastProduct.set(e.currentTarget.getAttribute('data-id') || e.currentTarget.getAttribute('data-slide-id'));
        this.hidden = true;
    };
    savePos = () => {
        if (!this.el.dataset.id)
            return;
        const lastCategories = store.lastCategories.get();
        const items = Array.from(this.el.querySelectorAll('.category__list .category__text,.category__list .category__product, .category__list .search-results__product, .catalog-push'));
        const seen = items.filter(el => el.classList.contains('category__product') ||
            el.classList.contains('search-results__product')).length;
        if (lastCategories.length >= MAX_LAST_STATES)
            lastCategories.shift();
        const category = lastCategories.find(cat => cat.id === this.el.dataset.id);
        const filters = this.el.dataset.filters;
        const catObj = {
            items,
            id: this.el.dataset.id,
            stateIdx: this.idx,
            seen,
            filters,
            minPageLoaded: category?.minPageLoaded || this.minPageLoaded,
            top: document.scrollingElement.scrollTop,
            date: Date.now()
        };
        lastCategories.push(catObj);
        lastCategories.sort((a, b) => b.date - a.date);
        store.lastCategories.set(lastCategories);
        this.hidden = true;
    };
    loadNewPage(page, direction = 1) {
        if (this.loading)
            return;
        this.loading = true;
        this.parent.pageManager.loading = true;
        const link = this.endpoint + (~this.endpoint.indexOf('?') ? '&' : '?') + 'page=' + page;
        if (link) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest();
                xhr.withCredentials = true;
                xhr.responseType = 'document';
                xhr.open('GET', link, true);
                xhr.setRequestHeader('X-Fursac-Async', 'true');
                xhr.onload = (event) => {
                    this.minPageLoaded = Math.min(this.minPageLoaded, page);
                    window.history.replaceState({ idx: this.idx }, '', link);
                    this.onPageLoaded(event, page, direction);
                    resolve();
                };
                xhr.send();
            });
        }
        else {
            return new Promise(resolve => {
                console.warn('No endpoint set to load new page'); // eslint-disable-line
                resolve();
            });
        }
    }
    onPageLoaded = ({ currentTarget: xhr }, pageIndex, direction) => {
        this.loading = false;
        this.parent.pageManager.loading = false;
        const page = xhr.response;
        extractInfoFromXhr(xhr);
        xhr.onload = null;
        const items = Array.from(page.querySelectorAll('.category__list .category__text, .category__list .category__product, .category__list .search-results__product'));
        const allItems = Array.from(page.querySelectorAll('.category__list .category__text, .category__list .catalog-push,.category__list .category__product, .category__list .search-results__product'));
        if (direction === 1)
            this.refs.categoryList.append(...allItems);
        else
            this.refs.categoryList.prepend(...allItems);
        // this.el.querySelector('.pagination.next').outerHTML = page.querySelector('.pagination.next').outerHTML
        this.refs.loadMore?.setAttribute('href', page.querySelector('.pagination.next a')?.getAttribute('href'));
        if (page.querySelector('.pagination.prev a'))
            this.refs.loadLess?.setAttribute('href', page.querySelector('.pagination.prev a')?.getAttribute('href'));
        forceArray(this.modules.pagination).forEach(p => {
            p.onPageLoaded(pageIndex, items.length, direction);
        });
        if (this.preloadingPages)
            return;
        this.modules.revealList.reset();
        updatePageLinks();
        const parent = this.parent;
        parent.pageManager.watch();
        browser.waitRepaint(() => {
            this.refresh();
            this.io.disconnect();
            for (let i = 0; i < this.refs.products.length; i++) {
                this.io.observe(this.refs.products[i]);
                this.cullingIo.observe(this.refs.products[i]);
            }
        });
    };
    resize() {
        super.resize();
    }
}
export default CategoryProducts;
